export const courtsData = [
  {
    id: 1,
    name: "Court Central",
    type: "central",
    description: "Court principal — Compétitions et matchs officiels. Surface aux normes internationales ITF.",
    icon: "ri-vip-crown-line",
    features: ["Surface ITF", "Gradins", "Éclairage nocturne", "Tableau d'affichage"],
    image: "https://public.readdy.ai/ai/img_res/edited_8c85ee8f741e462064d0db493a5f4bf3_24a1fddf.jpg"
  },
  {
    id: 2,
    name: "Court 1",
    type: "standard",
    description: "Court standard — Entraînements avancés et matchs amicaux de haut niveau.",
    icon: "ri-building-line",
    features: ["Surface rénovée", "Éclairage LED", "Filets professionnels"],
    image: "https://public.readdy.ai/ai/img_res/edited_74d7b706fcbbbdb6e9628b93eb34a7c8_24a1fddf.jpg"
  },
  {
    id: 3,
    name: "Court 2",
    type: "standard",
    description: "Court standard — Idéal pour les sessions d'entraînement et les cours particuliers.",
    icon: "ri-building-line",
    features: ["Surface rénovée", "Éclairage LED", "Zone d'échauffement"],
    image: "https://public.readdy.ai/ai/img_res/edited_d42c86a082205479c8c94885c5e287c5_24a1fddf.jpg"
  },
  {
    id: 4,
    name: "Court 3",
    type: "standard",
    description: "Court standard — Parfait pour les tournois interclubs et les événements.",
    icon: "ri-building-line",
    features: ["Surface rénovée", "Éclairage LED", "Accès vestiaires"],
    image: "https://public.readdy.ai/ai/img_res/edited_ef13eeaa809de1985b44dbc799c53251_24a1fddf.jpg"
  },
  {
    id: 5,
    name: "Training Court 4A",
    type: "training",
    description: "Court d'entraînement — Dédié aux séances collectives et au perfectionnement technique.",
    icon: "ri-run-line",
    features: ["Surface training", "Filets mobiles", "Zone multi-exercices"],
    image: "https://public.readdy.ai/ai/img_res/edited_70a38c8cc4ddce2ca3e10514ca638ba3_24a1fddf.jpg"
  },
  {
    id: 6,
    name: "Training Court 4B",
    type: "training",
    description: "Court d'entraînement — Espace polyvalent pour débutants et stages intensifs.",
    icon: "ri-run-line",
    features: ["Surface training", "Murs de pratique", "Équipements pédagogiques"],
    image: "https://public.readdy.ai/ai/img_res/edited_cc20a260b59c5fa5c13fdceef2e5bf6d_24a1fddf.jpg"
  }
];

export const keyNumbersData = [
  { value: 6, suffix: "", label: "Courts disponibles", icon: "ri-flag-line" },
  { value: 16, suffix: "h", label: "Ouvert 7j/7 — 6h à 22h", icon: "ri-time-line" },
  { value: 2, suffix: "", label: "Tournois ITF J30 organisés", icon: "ri-trophy-line" },
  { value: 8, suffix: "+", label: "Coachs certifiés", icon: "ri-user-star-line" },
  { value: 20, suffix: "", label: "Sparring Partners", icon: "ri-team-line" },
  { value: 40, suffix: "", label: "Enfants à l'École de Tennis", icon: "ri-heart-pulse-line" }
];

export const visionPointsData = [
  "Revalorisation complète du club — infrastructure et positionnement",
  "Formation de coaches certifiés niveau international",
  "Construction et rénovation de courts aux normes ITF",
  "Extension Padel — sport en pleine expansion en Afrique",
  "Rayonnement international — tournois et partenariats"
];

export const heroBadgesData = [
  "Tournois ITF",
  "6 Courts",
  "Certifié International"
];